import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api, { fmtErr } from "../api";
import AuthShell, { darkInput, darkLabel } from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Le mot de passe doit contenir au moins 8 caractères.");
    if (password !== confirm) return setError("Les mots de passe ne correspondent pas.");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Nouveau mot de passe"
      subtitle="Choisissez un nouveau mot de passe sécurisé."
      footer={<Link to="/login" className="font-semibold text-cyan-400 hover:text-cyan-300">← Retour à la connexion</Link>}
    >
      {!token && <p className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="reset-invalid">Lien invalide : jeton manquant.</p>}
      {done ? (
        <div className="rounded-lg border border-emerald-400/30 bg-emerald-500/10 px-4 py-5 text-center" data-testid="reset-success">
          <ShieldCheck className="mx-auto h-8 w-8 text-emerald-400" />
          <p className="mt-3 text-sm text-slate-200">Mot de passe mis à jour avec succès.</p>
          <p className="mt-1 text-xs text-slate-500">Redirection vers la connexion…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className={darkLabel}>Nouveau mot de passe</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="8 caractères minimum" className={darkInput} data-testid="reset-password-input" />
          </div>
          <div>
            <Label className={darkLabel}>Confirmation</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••" className={darkInput} data-testid="reset-confirm-input" />
          </div>
          {error && <p className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="reset-error">{error}</p>}
          <Button type="submit" disabled={submitting || !token}
            className="w-full bg-cyan-500 font-semibold text-[#05070B] hover:bg-cyan-400" data-testid="reset-submit-button">
            {submitting ? "Mise à jour…" : "Réinitialiser le mot de passe"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
